import { MODAL_TYPE_DELETE_POST } from '@wix/communities-blog-client-common';
import { handlePostDelete } from '../../../common/services/handle-post-delete';

export const modalResolverMapByType = {
  [MODAL_TYPE_DELETE_POST]: handlePostDelete({ permanently: false }),
};
